var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "container"
  }, [_c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.CUSTOM_FIELD,
      "field": _vm.partnerId
    }
  }, [_c('v-autocomplete', {
    ref: "autocomplete",
    attrs: {
      "label": _vm.label,
      "loading": _vm.isLoading,
      "items": _vm.items,
      "item-text": "name",
      "item-value": "id",
      "search-input": _vm.search,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "clearable": "",
      "flat": "",
      "outlined": "",
      "multiple": "",
      "return-object": "",
      "chips": "",
      "data-test-custom-field-selection": "",
      "menu-props": {
        maxWidth: _vm.menuWidth,
        offsetY: true
      }
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.search = $event;
      }
    },
    scopedSlots: _vm._u([!_vm.disabled ? {
      key: "selection",
      fn: function fn(data) {
        return [_c('draggable', {
          attrs: {
            "id": data.index,
            "list": _vm.selectedCustomFields,
            "animation": true,
            "group": "customFields",
            "ghost-class": "ghost-chip",
            "sort": true,
            "move": _vm.move
          },
          on: {
            "change": _vm.handleCustomFieldOrderChange
          }
        }, [_c('v-chip', {
          key: data.index,
          attrs: {
            "draggable": ""
          },
          on: {
            "mousedown": function mousedown($event) {
              $event.stopPropagation();
            },
            "click": function click($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: _vm.selectedCustomFields[data.index],
            callback: function callback($$v) {
              _vm.$set(_vm.selectedCustomFields, data.index, $$v);
            },
            expression: "selectedCustomFields[data.index]"
          }
        }, [_vm.selectedCustomFields[data.index].icon ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.selectedCustomFields[data.index].icon) + " ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.selectedCustomFields[data.index].titleReadable) + " ")], 1)], 1)];
      }
    } : null, {
      key: "no-data",
      fn: function fn() {
        return [_vm.isLoading ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("customField.selectCustomFields.searching")) + " ")])], 1)], 1) : _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.search && _vm.search.length >= 2 ? _vm.$t("tag.selectTags.noneFound") : _vm.$t("tag.selectTags.typeToSearch")) + " ")])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item,
            attrs = _ref.attrs,
            on = _ref.on;
        return [_c('v-list-item', _vm._g(_vm._b({
          staticClass: "custom-field-list-item",
          attrs: {
            "data-test-custom-field-selection-item": ""
          }
        }, 'v-list-item', attrs, false), on), [_c('v-list-item-icon', [_c('custom-field-detail-icon', {
          attrs: {
            "type": item.type
          }
        })], 1), _c('v-list-item-content', {
          staticStyle: {
            "min-width": "0"
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center",
          staticStyle: {
            "min-width": "0"
          }
        }, [_c('span', {
          staticClass: "text-truncate",
          staticStyle: {
            "min-width": "0"
          }
        }, [_vm._v(_vm._s(item.name))])]), item.hint ? _c('v-list-item-subtitle', {
          staticClass: "text-truncate",
          staticStyle: {
            "min-width": "0"
          }
        }, [_vm._v(" " + _vm._s(item.hint) + " ")]) : _vm._e()], 1)], 1)];
      }
    }], null, true),
    model: {
      value: _vm.selectedCustomFields,
      callback: function callback($$v) {
        _vm.selectedCustomFields = $$v;
      },
      expression: "selectedCustomFields"
    }
  }), _vm.showManageButton ? _c('div', {
    staticClass: "d-flex mt-n7 mb-n2"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": ""
    },
    on: {
      "click": function click() {
        return new _vm.CustomField({
          partnerId: _vm.partnerId
        }).goTo(_vm.$router).table();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("views.CustomFieldList.goToCustomFields")) + " ")])], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }